import styled from 'styled-components'
import { Tooltip } from 'antd'

const AntTooltipStyled = styled(Tooltip)`
  margin: 0 !important;
  padding: 10px;
`
export default AntTooltipStyled
